'use strict';

import coordinator from './infra/coordinator.mjs';

coordinator.initialize();
